/**
 * Levels of errors
 */
export enum Level {
	/** The view crashes/returns an error view instead of content. Does not continue gracefully. */
	Fatal = 'fatal',
	/** An error has prevented intended usage, but the app is still running */
	Error = 'error',
	/** A problem that doesn't interfere with usage has occured */
	Warning = 'warning',
	/** Something noteworthy has occured */
	Info = 'info',
	/** Something development-related has occured */
	Debug = 'debug',
}
